// import { initialState } from "../reducers/locationReducer";

// Action types
export const SET_ADDRESS = "SET_ADDRESS";
export const SET_CITY = "SET_CITY";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_COUNTRY_CODE = "SET_COUNTRY_CODE";
export const SET_LAT = "SET_LAT";
export const SET_LNG = "SET_LNG";
export const SET_MARKERPOSITION = "SET_MARKERPOSITION";
export const SET_LOCATIONOBJECT = "SET_LOCATIONOBJECT";
export const INITIALSTATE = "INITIALSTATE";
export const SET_ELEVATION = "SET_ELEVATION";

export const setLocationCountry = (country) => {
  return {
    type: SET_COUNTRY,
    payload: country,
  };
};

export const setLocationCity = (city) => {
  return {
    type: SET_CITY,
    payload: city,
  };
};

export const setLocationAddress = (address) => {
  return {
    type: SET_ADDRESS,
    payload: address,
  };
};
export const setLocationCountryCode = (countrycode) => {
  return {
    type: SET_COUNTRY_CODE,
    payload: countrycode,
  };
};
export const setLocationLat = (lat) => {
  return {
    type: SET_LAT,
    payload: lat,
  };
};
export const setLocationMarkerPosition = ({ lat, lng }) => {
  return {
    type: SET_MARKERPOSITION,
    payload: { lat, lng },
  };
};
export const setLocationLng = (lng) => {
  return {
    type: SET_LNG,
    payload: lng,
  };
};

export const setLocationObject = ({
  address,
  city,
  country,
  countryShortCode,
  markerPosition: { lat, lng },
  elevation,
}) => {
  return {
    type: SET_LOCATIONOBJECT,
    payload: {
      address,
      city,
      country,
      countryShortCode,
      markerPosition: { lat, lng },
      elevation,
    },
  };
};

export const setElevation = ({ elevation }) => {
  return {
    type: SET_ELEVATION,
    payload: {
      elevation,
    },
  };
};

export const setInitialState = () => {
  return {
    type: INITIALSTATE,
  };
};
